import { Box, Card, CardActionArea, CardContent, Icon, Tooltip, useTheme } from "@mui/material";
import MapboxDraw from "@mapbox/mapbox-gl-draw";
import BboxSvg from "pages/geoscape-data/clip/clip-ui/icons/bbox.svg?react";
import CircleSvg from "pages/geoscape-data/clip/clip-ui/icons/circle.svg?react";
import PolygonSvg from "pages/geoscape-data/clip/clip-ui/icons/polygon.svg?react";

interface DrawToolbarProps {
  draw: MapboxDraw;
  currentMode: string;
  onModeChange: (mode: string) => void;
}

const drawTools = [
  { mode: "draw_rectangle", label: "Rectangle", Icon: BboxSvg },
  { mode: "draw_polygon", label: "Polygon", Icon: PolygonSvg },
  { mode: "draw_circle", label: "Circle", Icon: CircleSvg },
] as const;

export function DrawToolbar({ draw, currentMode, onModeChange }: DrawToolbarProps) {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";
  const fill = isDark ? "white" : "black";

  return (
    <Box display="flex" flexDirection="row" gap={1}>
      {drawTools.map((tool) => (
        <Tooltip key={tool.mode} title={tool.label}>
          <Card
            variant="outlined"
            sx={{
              p: 0,
              width: 40,
              height: 40,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              bgcolor: currentMode === tool.mode ? "action.selected" : "transparent",
              "&:hover": { bgcolor: "action.hover" },
            }}
          >
            <CardActionArea
              sx={{
                width: "100%",
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              onClick={() => {
                draw.changeMode(tool.mode as any);
                onModeChange(tool.mode);
              }}
            >
              <Icon sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                <tool.Icon fill={fill} />
              </Icon>
            </CardActionArea>
          </Card>
        </Tooltip>
      ))}
    </Box>
  );
}
